import { useSelector } from 'react-redux'
import { parseDate, today } from '../../../config/dayjsConfig'
import { periodGroupLabel } from '../../../redux/context/fiscalYears/utils'
import { investmentsPageSelector } from '../../../redux/pages/investments/selectors'
import { customPeriodGroup } from '../../../utils/periodGroups/utils'
import { useCtxFiscalYears } from '../../fiscalYear/queries/report/useCtxFiscalYears'

export const useFiscalYearToDateLabel = () => {
  const { date } = useSelector(investmentsPageSelector)
  const { data: fiscalYears = [] } = useCtxFiscalYears()

  const selectedDate = parseDate(date)
  const todayParsed = today()
  const currentYear = selectedDate?.year() || todayParsed?.year() || today().year()

  // Find fiscal year for the selected date's year
  const targetFiscalYear = fiscalYears.find(f => f.year === currentYear)

  let startDate
  if (targetFiscalYear?.startDate) {
    startDate = parseDate(targetFiscalYear.startDate)
  } else {
    // Fallback: find current year fiscal year and adjust year
    const currentFiscalYear = fiscalYears.find(f => f.year === (todayParsed?.year() || today().year()))
    if (currentFiscalYear?.startDate) {
      startDate = parseDate(currentFiscalYear.startDate)?.set('year', currentYear)
    } else {
      // Fallback: use parseDate for year start
      startDate = parseDate(`${currentYear}-01-01`)
    }
  }

  return periodGroupLabel(
    customPeriodGroup(startDate || todayParsed || today(), selectedDate || todayParsed || today())
  )
}
